const stringUtility = {
    toKebabCase: (s) => {
        return s.replace(/([a-z])([A-Z])/g, "$1-$2")
            .replace(/[\s_]+/g, '-')
            .toLowerCase();
    },
    toHashCode: (s) => {
        let hash = 0, i, chr;
        if (s.length === 0)
            return hash;
        for (i = 0; i < s.length; i++) {
            chr = s.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
};
export default stringUtility;
